// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151247/js/" + chunkId + "." + {"44":"87a189e9","225":"a0e7014d","481":"18d0399c","486":"11a09f7b","770":"971bf95b"}[chunkId] + ".0.40372194104380943.chunk.js";
};